var _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "155.000000pt",
    height: "87.000000pt",
    viewBox: "0 0 155.000000 87.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,87.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 768 c-35 -13 -57 -88 -25 -88 10 0 15 10 15 29 0 36 13 41 97 41 47 0 64 3 61 12 -5 14 -115 18 -148 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286 773 c-14 -15 11 -23 69 -23 82 0 95 -6 95 -41 0 -19 5 -29 15 -29 21 0 19 43 -3 69 -14 18 -30 23 -94 26 -42 2 -79 1 -82 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287 693 c-11 -10 -8 -211 3 -218 6 -4 10 35 10 109 0 64 -1 116 -3 116 -2 0 -7 -3 -10 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 585 l0 -105 49 0 48 0 -1 105 -1 105 -47 0 -48 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 585 c0 -77 3 -105 13 -105 9 0 12 28 12 105 0 77 -3 105 -12 105 -10 0 -13 -28 -13 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 579 c0 -64 4 -108 9 -105 13 8 14 216 1 216 -6 0 -10 -43 -10 -111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 585 c0 -105 0 -105 24 -105 24 0 25 1 28 105 l3 105 -27 0 -28 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 585 l0 -105 45 0 45 0 0 105 0 105 -45 0 -45 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 583 c2 -74 7 -108 16 -111 9 -3 12 23 12 107 0 93 -2 111 -15 111 -13 0 -15 -16 -13 -107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 585 c0 -98 1 -105 20 -105 19 0 20 7 20 105 0 98 -1 105 -20 105 -19 0 -20 -7 -20 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 586 c0 -59 4 -108 10 -111 6 -4 10 33 10 104 0 67 -4 111 -10 111 -6 0 -10 -41 -10 -104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 585 l0 -105 28 0 27 0 0 105 0 105 -27 0 -28 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 580 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10 110 -6 0 -10 -43 -10 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 586 c0 -59 4 -108 10 -111 6 -4 10 33 10 104 0 67 -4 111 -10 111 -6 0 -10 -41 -10 -104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 579 c0 -71 4 -108 10 -104 6 3 10 52 10 111 0 63 -4 104 -10 104 -6 0 -10 -44 -10 -111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 585 c0 -98 1 -105 20 -105 19 0 20 7 20 105 0 98 -1 105 -20 105 -19 0 -20 -7 -20 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 585 l0 -105 43 0 42 0 0 105 0 105 -42 0 -43 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 585 l0 -105 30 0 30 0 0 105 0 105 -30 0 -30 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 430 c0 -7 227 -10 660 -10 433 0 660 3 660 10 0 7 -227 10 -660 10 -433 0 -660 -3 -660 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 279 l0 -109 48 0 48 0 0 109 0 109 -48 0 -48 1 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 280 c0 -76 3 -111 11 -108 15 5 15 211 0 216 -8 3 -11 -32 -11 -108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 280 c0 -60 4 -110 8 -110 5 0 8 50 8 110 0 61 -4 110 -8 110 -4 0 -8 -49 -8 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 280 l0 -110 25 0 25 0 0 110 0 110 -25 0 -25 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 279 l0 -109 45 0 45 0 0 109 0 108 -45 0 -45 0 0 -108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 280 c0 -91 3 -110 15 -110 12 0 15 19 15 110 0 91 -3 110 -15 110 -12 0 -15 -19 -15 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 280 c0 -103 1 -110 20 -110 19 0 20 7 20 110 0 103 -1 110 -20 110 -19 0 -20 -7 -20 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 280 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10 110 -6 0 -10 -43 -10 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 280 l0 -110 28 0 27 0 0 110 0 110 -27 0 -28 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 280 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10 110 -6 0 -10 -43 -10 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 280 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10 110 -6 0 -10 -43 -10 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 280 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10 110 -6 0 -10 -43 -10 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 280 c0 -103 1 -110 20 -110 19 0 20 7 20 110 0 103 -1 110 -20 110 -19 0 -20 -7 -20 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159 386 c0 0 -1 -49 -2 -109 l-2 -107 43 0 42 0 0 109 0 110 -40 -1 c-22 0 -40 -1 -41 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 280 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10 110 -6 0 -10 -43 -10 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 280 l0 -110 30 0 30 0 0 110 0 110 -30 0 -30 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 183 c-12 -12 -6 -51 12 -72 14 -18 29 -22 91 -24 52 -1 76 2 78 11 4 9 -13 12 -60 12 -84 0 -97 6 -97 40 0 29 -12 45 -24 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 183 c-3 -3 -6 -19 -6 -34 0 -33 -12 -37 -103 -41 -87 -4 -70 -23 20 -22 67 2 80 5 95 24 10 12 18 33 18 46 0 24 -12 38 -24 27z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.01b7b8c419fc757e845d7d6fbea0fb7e.svg";
export { ForwardRef as ReactComponent };